import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ProfileModal from '../Components/Profile';
import SidebarBohol from '../Components/Bohol/SidebarBohol';
import NavbarBohol from '../Components/Bohol/NavbarBohol';
import HomeBohol from '../Components/Bohol/HomeBohol';
import AboutAdmin from '../Admin/AboutAdmin';
import HelpAdmin from '../Admin/HelpAdmin';
import IAProfileAdd from '../Admin/iaProfilingAdd';
import IAProfileEdit from '../Admin/iaProfilingEdit';
import IAOfficers from '../Admin/iaOfficers';
import IAOfficersFormAdd from '../Admin/iaOfficersFormAdd';
import IAOfficersFormEdit from '../Admin/iaOfficersFormEdit';
import IATraining from '../Admin/iaTraining';
import ImtContract from '../Admin/imtContract';
import RsbaMasterlist from '../Admin/rsbaMasterlist';
import FBmasterlist from '../Admin/fbMasterlist';
import Year from '../Admin/Year';
import Machineries from '../Admin/Machineries';
import PFS from '../Admin/PFS';
import NIS from '../Admin/nis';
import NISmachineries from '../Admin/NisMachineries';
import NISmasterlist from '../Admin/nisMasterlist';
import CIS from '../Admin/cis';
import Convergence from '../Admin/convergence';
import Template from '../Admin/template';
import IaManagement from '../Admin/IaManagement';

const DashboardBohol = ({ darkMode, toggleDarkMode }) => {
  const [selectedContent, setSelectedContent] = useState('HomeBohol');
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [showFormAdd, setShowFormAdd] = useState(false);
  const [showFormEdit, setShowFormEdit] = useState(false);
  const [selectedNisId, setSelectedNisId] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedProfilingCategory, setSelectedProfilingCategory] = useState(null);

  const handleNavClick = (item, options = {}) => {
    const profilingCategories = ['SRIP', 'SIS/SIP', 'PIP'];

    if (profilingCategories.includes(item)) {
      setSelectedProfilingCategory(item);
      setSelectedContent('Year');
      setShowFormAdd(false);
      setShowFormEdit(false);
      return;
    }

    if (['NISmachineries', 'NISmasterlist'].includes(item)) {
      setSelectedNisId(options.nisId || null);
      // Handle both old {row} format and new flat {nisId, iaName, isName, year} format
      const rowCtx = options.row || {
        id: options.nisId || null,
        ia_name: options.iaName || null,
        is_name: options.isName || null,
      };
      setSelectedRow(rowCtx);
      setSelectedYear(options.year || null);
    }

    if (item === 'IAOfficersFormAdd' && selectedContent === 'IAOfficers') {
      setShowFormAdd(true);
    } else if (item === 'IAOfficersFormEdit' && selectedContent === 'IAOfficers') {
      setShowFormEdit(true);
    } else if (item === 'IAOfficers' && options.closeForm) {
      setShowFormAdd(false);
      setShowFormEdit(false);
      setSelectedContent('IAOfficers');
    } else {
      setSelectedContent(item);
      setShowFormAdd(false);
      setShowFormEdit(false);
      if (item !== 'Year') {
        setSelectedProfilingCategory(null);
      }
    }
  };

  const handleBackToNisOrCisMenu = () => {
    const pendingCisReturn = localStorage.getItem('cisMachineriesReturn');
    if (pendingCisReturn) {
      handleNavClick('CIS');
      return;
    }
    handleNavClick('NIS');
  };

  useEffect(() => {
    const handleCustomNavigation = (e) => {
      handleNavClick(e.detail.item, e.detail.options || {});
    };

    window.addEventListener('navigateTo', handleCustomNavigation);
    return () => window.removeEventListener('navigateTo', handleCustomNavigation);
  }, []);

  const handleSidebarToggle = (expanded) => {
    setIsSidebarExpanded(expanded);
  };

  const renderContent = () => {
    switch (selectedContent) {
      case 'HomeBohol':
        return <HomeBohol darkMode={darkMode} toggleDarkMode={toggleDarkMode} />;
      case 'AboutAdmin':
        return <AboutAdmin />;
      case 'HelpAdmin':
        return <HelpAdmin />;
      case 'IAProfileAdd':
        return <IAProfileAdd darkMode={darkMode} toggleDarkMode={toggleDarkMode} />;
      case 'IAProfileEdit':
        return <IAProfileEdit darkMode={darkMode} toggleDarkMode={toggleDarkMode} />;
      case 'IAOfficers':
        return (
          <div style={{ display: 'flex', gap: '20px' }}>
            <IAOfficers
              darkMode={darkMode}
              toggleDarkMode={toggleDarkMode}
              onSelect={handleNavClick}
              showFormAdd={showFormAdd}
              showFormEdit={showFormEdit}
              onBack={handleBackToNisOrCisMenu}
            />
            {(showFormAdd || showFormEdit) && (
              <div style={{ width: '50%' }}>
                {showFormAdd && (
                  <IAOfficersFormAdd
                    darkMode={darkMode}
                    toggleDarkMode={toggleDarkMode}
                    onSelect={handleNavClick}
                  />
                )}
                {showFormEdit && (
                  <IAOfficersFormEdit
                    darkMode={darkMode}
                    toggleDarkMode={toggleDarkMode}
                    onSelect={handleNavClick}
                  />
                )}
              </div>
            )}
          </div>
        );
      case 'IATraining':
        return <IATraining darkMode={darkMode} toggleDarkMode={toggleDarkMode} />;
      case 'ImtContract':
        return <ImtContract darkMode={darkMode} toggleDarkMode={toggleDarkMode} onSelect={handleNavClick} onBack={handleBackToNisOrCisMenu} />;
      case 'RsbaMasterlist':
        return <RsbaMasterlist darkMode={darkMode} toggleDarkMode={toggleDarkMode} />;
      case 'FBmasterlist':
        return <FBmasterlist darkMode={darkMode} toggleDarkMode={toggleDarkMode} setShowimtContract={handleBackToNisOrCisMenu} />;
      case 'Year':
        return <Year darkMode={darkMode} toggleDarkMode={toggleDarkMode} onSelect={handleNavClick} initialCategory={selectedProfilingCategory} />;
      case 'Machineries':
        return <Machineries darkMode={darkMode} toggleDarkMode={toggleDarkMode} onBack={handleBackToNisOrCisMenu} />;
      case 'PFS':
        return <PFS onBack={handleBackToNisOrCisMenu} />;
      case 'NIS':
        return (
          <NIS
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
            onSelect={handleNavClick}
            isSidebarExpanded={isSidebarExpanded}
          />
        );
      case 'NISmasterlist':
        return (
          <NISmasterlist
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
            onSelect={handleNavClick}
            nisId={selectedNisId}
            iaName={selectedRow?.ia_name}
            isName={selectedRow?.is_name}
            year={selectedYear || new Date().getFullYear()}
            isSidebarExpanded={isSidebarExpanded}
            onBack={handleBackToNisOrCisMenu}
          />
        );
      case 'NISmachineries':
        return (
          <NISmachineries
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
            onSelect={handleNavClick}
            nisId={selectedNisId}
            iaName={selectedRow?.ia_name}
            year={selectedYear || new Date().getFullYear()}
            isSidebarExpanded={isSidebarExpanded}
            onBack={handleBackToNisOrCisMenu}
          />
        );
      case 'CIS':
        return (
          <CIS
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
            onSelect={handleNavClick}
            isSidebarExpanded={isSidebarExpanded}
          />
        );
      case 'Convergence':
        return (
          <Convergence
            darkMode={darkMode}
            isSidebarExpanded={isSidebarExpanded}
            toggleDarkMode={toggleDarkMode}
            onSelect={handleNavClick}
            onBack={handleBackToNisOrCisMenu}
            forceEditable
          />
        );
      case 'IaManagement':
        return (
          <IaManagement
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
            onSelect={handleNavClick}
          />
        );
      case 'Template':
        return <Template />;
      case 'ProfileModal':
        return <ProfileModal />;
      default:
        return <HomeBohol />;
    }
  };

  return (
    <DashboardContainer>
      <NavbarBohol
        onSelect={handleNavClick}
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
      />
      <MainWrapper>
        <SidebarBohol
          isExpanded={isSidebarExpanded}
          onSelect={handleNavClick}
          selectedContent={selectedContent}
          onToggleSidebar={handleSidebarToggle}
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
        />
        <Content
          isExpanded={isSidebarExpanded}
          isHelpView={selectedContent === 'HelpAdmin'}
        >
          {renderContent()}
        </Content>
      </MainWrapper>
    </DashboardContainer>
  );

};

export default DashboardBohol;


const DashboardContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  position: relative; 
   overflow: hidden;
`;

const MainWrapper = styled.div`
  display: flex;
  flex: 1;
`;

const Content = styled.div`
  flex-grow: 1;
  margin-left: ${({ isExpanded, isHelpView }) => {
    if (isHelpView) {
      return '18px';
    }
    return isExpanded ? '6px' : '4px';
  }};
  transition: margin-left 0.2s ease;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: auto;
`;

const SplitContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  gap: 20px;
`;

const FormWrapper = styled.div`
  flex: 1;
  max-width: 46.2%;
  overflow: auto;
  background-color: ${props => (props.darkMode ? '#1a1a1a' : '#ffffff')};
  padding: 10px  /* Added padding-right: 20px */
  border-left: 20px solid #ccc;
  margin-top: 20px;
`;

